module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Change Password","action":{"change":"Change password"},"cannotChange":"Only the owner of the account may directly set their own password.","alert":{"mismatch":"Please check that your new passwords match.","success":"Success! Your password has been updated."}}}')
  delete Component.options._Ctor
}
